"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_router_1 = require("react-router");
const prop_types_1 = __importDefault(require("prop-types"));
const Index = ({ children, scrollElement = 'root' }) => {
    const location = react_router_1.useLocation();
    react_1.useEffect(() => {
        if (scrollElement) {
            const element = document.getElementById(scrollElement);
            element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }, [location.pathname, scrollElement]);
    return children || null;
};
Index.propTypes = {
    children: prop_types_1.default.any,
    scrollElement: prop_types_1.default.string.isRequired,
};
exports.default = Index;
